import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets';
import { createServiceProvider } from '../util';

export default createServiceProvider({
  ...getServiceProvider('mailchimp'),
  titleToNamespace: true,
  avatarPath: avatars.mailchimp,
  logoPath: logos.mailchimp,
  hasConnectionStatus: false,
  defaultAuthenticationType: 'basic'
});
